// // src/components/Footer.js

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../services/firebaseConfig";
import styles from './Footer.module.css';

function Footer() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  return (
    <footer className={styles.footer}>
      <div>© {new Date().getFullYear()} Runas Archive. All rights reserved.</div>
      <div className={styles.adminFooter}>
        {user ? (
          <Link to="/admin/audio-releases">Admin Page</Link>
        ) : (
          <Link to="/admin/login">Admin</Link>
        )}
      </div>
    </footer>
  );
}

export default Footer;






// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { onAuthStateChanged, signOut } from "firebase/auth";
// import { auth } from "../services/firebaseConfig";
// import styles from './Footer.module.css';

// function Footer() {
//   const [user, setUser] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
//       setUser(currentUser);
//     });
//     return () => unsubscribe();
//   }, []);

//   const handleLogout = async () => {
//     await signOut(auth);
//     setUser(null);
//     navigate("/");
//   };

//   return (
//     <footer className={styles.footer}>
//       <div>© {new Date().getFullYear()} Runas Archive. All rights reserved.</div>
//       <div className={styles.adminFooter}>
//         {user ? (
//           <div className={styles.loggedInAdmin}>
//             <span>{user.email}</span>
//             <button onClick={handleLogout}>Logout</button>
//           </div>
//         ) : (
//           <Link to="/admin/login">Admin</Link>
//         )}
//       </div>
//     </footer>
//   );
// }

// export default Footer;


//TODO--- Make the "Go to Admin Btn when the admin is logged in. Check the components"


// import React from "react";
// import styles from './Footer.module.css';

// function Footer() {
//   return (
//     <footer className={styles.footer}>
//     © {new Date().getFullYear()} Runas Archive. All rights reserved. 
//     {/* <div className={styles.stars}>★★★★★</div> */}
//     </footer>
//   );
// }

// export default Footer;
